import $ from "jquery";

export const PersonalGoal = function () {
	const $page = $(".personal-goal");
	if ($page.length) {
		const $elems = {
			input: $("#personal-goal"),
			btnSubmit: $(".js-personal-goal-submit"),
		};
		const nextUrl = $page.attr("data-next-url") || "";

		const validateInput = () => {
			const hasValue = !!$elems.input.val().trim();
			$elems.btnSubmit.prop("disabled", !hasValue);
			return hasValue;
		};

		validateInput();
		$elems.input.on("input", validateInput);

		$elems.btnSubmit.on("click", function () {
			if ($elems.btnSubmit.hasClass("is-loading") || !validateInput()) {
				return;
			}

			$elems.btnSubmit.addClass("is-loading");

			$.ajax({
				url: window.CFG.ajaxUrl,
				type: "POST",
				data: {
					action: "save-custom-goal",
					nonce: window.CFG.nonce,
					custom_goal: $elems.input.val().trim(),
				},
				success: function (response) {
					if (response && response.success && nextUrl) {
						window.location.href = nextUrl;
						return;
					}

					alert(
						(response && response.data && response.data.message) ||
							"Failed to save custom goal",
					);
				},
				error: function () {
					alert("An error occurred while saving your custom goal. Please try again.");
				},
				complete: function () {
					$elems.btnSubmit.removeClass("is-loading");
				},
			});
		});
	}

	$(".js-personal-goal-editor").each(function () {
		const $editor = $(this);
		const $overlay = $editor.find(".js-personal-goal-editor-overlay");
		const $input = $editor.find(".js-personal-goal-editor-input");
		const $save = $editor.find(".js-personal-goal-editor-save");
		const $error = $editor.find(".js-personal-goal-editor-error");
		let previousFocus = null;

		const closeEditor = () => {
			$overlay.prop("hidden", true);
			$("body").removeClass("personal-goal-editor-is-open");
			$error.prop("hidden", true).text("");
			if (previousFocus) previousFocus.focus();
		};

		$editor.find(".js-personal-goal-editor-open").on("click", function () {
			previousFocus = this;
			$overlay.prop("hidden", false);
			$("body").addClass("personal-goal-editor-is-open");
			$input.trigger("focus");
		});

		$editor.find(".js-personal-goal-editor-close").on("click", closeEditor);
		$overlay.on("click", function (event) {
			if (event.target === this) closeEditor();
		});
		$overlay.on("keydown", function (event) {
			if (event.key === "Escape") closeEditor();
		});

		$save.on("click", function () {
			const customGoal = $input.val().trim();
			if (!customGoal) {
				$error.text("Please enter a personal learning goal.").prop("hidden", false);
				$input.trigger("focus");
				return;
			}

			$save.prop("disabled", true);
			$error.prop("hidden", true).text("");

			$.ajax({
				url: window.CFG.ajaxUrl,
				type: "POST",
				data: {
					action: "save-custom-goal",
					nonce: window.CFG.nonce,
					custom_goal: customGoal,
				},
				success: function (response) {
					if (!response || !response.success) {
						$error
							.text((response && response.data && response.data.message) || "Failed to save your learning goal.")
							.prop("hidden", false);
						return;
					}

					const savedGoal = response.data.custom_goal || customGoal;
					$("[data-personal-goal-value]").each(function () {
						const value = $(this).data("personal-goal-uppercase") ? savedGoal.toUpperCase() : savedGoal;
						$(this).text(value);
					});
					$("#personal-goal").val(savedGoal);
					$(".js-personal-goal-editor-input").val(savedGoal);
					closeEditor();
				},
				error: function () {
					$error.text("An error occurred while saving your learning goal. Please try again.").prop("hidden", false);
				},
				complete: function () {
					$save.prop("disabled", false);
				},
			});
		});
	});
};
